<template>
  <div class="callback-tvi-container"></div>
</template>

<script>
import _ from 'lodash'

import API from '@/lib/api'
import { generateAuthorizationRequestHeader } from '@/lib/services'

export default {
  name: 'CallbackTvi',
  methods: {
    getAccessToken(path) {
      const pathWithoutHash = path.substring(1)
      const hashParameterList = pathWithoutHash.split('&')
      const idToken = _.find(hashParameterList, parameter => _.includes(parameter, 'id_token'))
      return _.replace(idToken, 'id_token=', '')
    },
  },
  mounted() {
    this.$session.destroy()
    const access_token = this.getAccessToken(this.$route.hash)
    const authFrom = 'tvi'

    this.$http
        .get(API.AUTHORIZATION.SCOPE, {
          headers: {
            ...generateAuthorizationRequestHeader(access_token),
          },
        })
        .then(res => res.json())
        .then(
            response => {
              const { scope: scoped, staffInfo } = response.result

              const login = {
                access_token,
                scoped,
                name: staffInfo.staffId,
                email: staffInfo.email,
                auth_from: authFrom,
                loginTime: staffInfo.loginTime,
              }

              this.$session.set('chili', login)
              this.$router.push('/home')
            },
            error => {
              const { body: { statusCode, error: err, message } } = error

              console.error(`[GetScope] Response ${statusCode} ${err} ${message}`)

              const login = {
                status: 500,
                msg: 'ในการเชื่อมต่อกรุณาลองใหม่อีกครั้งค่ะ',
                auth_from: authFrom,
              }

              this.$session.set('error', login)
              this.$router.push('/')
            },
        )
  },
}
</script>
